import { Box, Typography } from '@mui/material';
import ChartSection from '../shared/ChartSection';
import { fmtMoney } from '../shared/formatters';

export default function TotalProfit({ data }) {
    if (!data) return null;

    return (
        <ChartSection id="total-profit" title="How much money has Congress made from trading?">
            <Box sx={{ textAlign: 'center', mb: 3 }}>
                <Typography sx={{ fontSize: '2.5rem', fontWeight: 700, color: 'success.main', fontFamily: t => t.typography.fontFamilyMono }}>
                    {fmtMoney(data.total_estimated_profit)}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.muted' }}>
                    Total estimated profit across {data.members_with_profit_data} members since 2013
                </Typography>
            </Box>
            <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1 }}>Top 10 Earners</Typography>
            {data.top_10?.map((m, i) => (
                <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75, borderBottom: i < 9 ? t => '1px solid ' + t.palette.custom.border.subtle : 'none' }}>
                    <Typography variant="body2" sx={{ color: 'text.primary' }}>{i + 1}. {m.name}</Typography>
                    <Typography variant="body2" sx={{ fontFamily: t => t.typography.fontFamilyMono, color: 'success.main', fontWeight: 600 }}>{fmtMoney(m.profit)}</Typography>
                </Box>
            ))}
        </ChartSection>
    );
}
